export default [
  {
    path: '/login',
    name: 'Login',
    component: () => import('../components/login/Login'),
    meta: { onlyAnonymous: true },
  }
];
